export enum FileTypeEnum {
  ANY = 'ANY',
  MEDIA = 'MEDIA',
  IMAGE = 'IMAGE',
  DOCUMENT = 'DOCUMENT',
  AUDIO = 'AUDIO',
}
